import Phaser from 'phaser';
import { GAME_CONFIG, COLORS } from '../data/GameConstants';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    // Create loading bar
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Background
    this.cameras.main.setBackgroundColor('#0A0505');

    // Loading text
    const loadingText = this.add.text(width / 2, height / 2 - 50, 'Loading...', {
      font: '32px Playfair Display',
      fill: '#FFD700'
    }).setOrigin(0.5);

    // Progress bar background
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x5D1916, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2, 320, 30);

    // Loading progress
    this.load.on('progress', (value) => {
      progressBar.clear();
      progressBar.fillStyle(0xFFD700, 1);
      progressBar.fillRect(width / 2 - 155, height / 2 + 5, 310 * value, 20);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });

    // Load placeholder assets (we'll replace these with real sprites later)
    this.createPlaceholderAssets();
  }

  createPlaceholderAssets() {
    // Create placeholder sprite textures programmatically
    const graphics = this.make.graphics({ x: 0, y: 0, add: false });

    // Player placeholder (green square)
    graphics.fillStyle(0x4CAF50);
    graphics.fillRect(0, 0, 32, 32);
    graphics.generateTexture('player_placeholder', 32, 32);
    graphics.clear();

    // Enemy placeholder (red square)
    graphics.fillStyle(0xF44336);
    graphics.fillRect(0, 0, 32, 32);
    graphics.generateTexture('enemy_placeholder', 32, 32);
    graphics.clear();

    // Anunnaki placeholder (blue square)
    graphics.fillStyle(0x2196F3);
    graphics.fillRect(0, 0, 32, 32);
    graphics.generateTexture('anunnaki_placeholder', 32, 32);
    graphics.clear();

    // Boss placeholder (large purple square)
    graphics.fillStyle(0x9C27B0);
    graphics.fillRect(0, 0, 64, 64);
    graphics.generateTexture('boss_placeholder', 64, 64);
    graphics.clear();

    // Ground tile placeholder
    graphics.fillStyle(0x3E2723);
    graphics.fillRect(0, 0, 32, 32);
    graphics.lineStyle(1, 0x5D4037);
    graphics.strokeRect(0, 0, 32, 32);
    graphics.generateTexture('ground_tile', 32, 32);
    graphics.clear();

    // Wall tile placeholder
    graphics.fillStyle(0x5D1916);
    graphics.fillRect(0, 0, 32, 32);
    graphics.generateTexture('wall_tile', 32, 32);
    graphics.clear();

    // Truth fragment placeholder (golden circle)
    graphics.fillStyle(0xFFD700);
    graphics.fillCircle(16, 16, 12);
    graphics.generateTexture('truth_fragment', 32, 32);
    graphics.clear();

    // Health potion placeholder
    graphics.fillStyle(0x4CAF50);
    graphics.fillCircle(16, 16, 10);
    graphics.generateTexture('health_potion', 32, 32);
    graphics.clear();

    // UI elements
    graphics.fillStyle(0x1A1A1A, 0.9);
    graphics.fillRect(0, 0, 200, 60);
    graphics.generateTexture('ui_panel', 200, 60);
    graphics.clear();

    graphics.destroy();
  }

  create() {
    // Transition to title screen
    this.scene.start('TitleScene');
  }
}
